export const FETCH_PAGE = 'FETCH_PAGE';
export const FETCHED_PAGES = 'FETCHED_PAGES_CHUNKS';
export const FETCHED_PAGES_TYPES = 'FETCHED_PAGES_TYPES';
export const DELETED_PAGE = 'DELETE_PAGE';
export const SELECTED_PAGE_TYPE = 'SELECTED_PAGE_TYPE';
export const CLOSE_ADD_PAGE_POPUP = 'CLOSE_ADD_PAGE_POPUP';
export const FETCHED_PAGES_TAGS_BY_PAGE_TYPE = 'FETCHED_PAGES_TAGS_BY_PAGE_TYPE';
export const SELECTED_PAGE_TAGS_DESTINATION = 'SELECTED_PAGE_TAGS_DESTINATION';
export const SELECTED_PAGE_TAGS_CONTINENT = 'SELECTED_PAGE_TAGS_CONTINENT';
export const SELECTED_PAGE_TAGS_TRIP_FORMAT = 'SELECTED_PAGE_TAGS_TRIP_FORMAT';
export const SELECTED_PAGE_TAGS_TYPE_OF_WORK = 'SELECTED_PAGE_TAGS_TYPE_OF_WORK';
export const SELECTED_PAGE_TAGS_TYPE_OF_WORK_TAG = 'SELECTED_PAGE_TAGS_TYPE_OF_WORK_TAG';
export const SELECTED_PAGE_TAGS_TYPE_OF_WORK_GROUP = 'SELECTED_PAGE_TAGS_TYPE_OF_WORK_GROUP';
export const SELECTED_PAGE_TAGS_ALL = 'SELECTED_PAGE_TAGS_ALL';
export const SELECT_STATUS_CODE = 'SELECT_STATUS_CODE';
export const UPDATE_REDIRECT_URL = 'UPDATE_REDIRECT_URL';
export const CLEAR_REDIRECT_URL = 'CLEAR_REDIRECT_URL';
export const CLEAR_STATUS_CODE = 'CLEAR_STATUS_CODE';
export const HAS_ERROR = 'HAS_ERROR';
export const PUBLISHED_PAGE = 'PUBLISHED_PAGE';
export const UNPUBLISHED_PAGE = 'UNPUBLISHED_PAGE';
export const UPDATE_TRANSLATION_SITE = 'UPDATE_TRANSLATION_SITE';
export const CLEAR_TRANSLATION_SITE = 'CLEAR_TRANSLATION_SITE';
export const FETCHED_EXISTING_PAGE_TRANSLATIONS = 'FETCHED_EXISTING_PAGE_TRANSLATIONS';
export const FETCHED_MISSING_PAGE_TRANSLATIONS = 'FETCHED_MISSING_PAGE_TRANSLATIONS';
export const UPDATE_ADD_TRANSLATION_SITES = 'UPDATE_ADD_TRANSLATION_SITES';
export const CLEAR_ADD_TRANSLATION_SITES = 'CLEAR_ADD_TRANSLATION_SITES';
export const SELECT_ALL_ADD_TRANSLATION_SITES = 'SELECT_ALL_ADD_TRANSLATION_SITES';


// WEBPACK FOOTER //
// ./src/containers/pages/types.js